import { Link } from 'react-router-dom';

const risks = [
  {
    icon: 'ri-virus-line',
    title: '恶意代码与病毒',
    description: '超过60%的破解版应用包含恶意代码，可能窃取您的个人数据、账号密码，甚至将设备变成"僵尸网络"的一部分。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私数据泄露',
    description: '破解版可后台偷取您的照片、位置、社交记录等隐私信息，轻则遭遇精准诈骗，重则面临身份盗用。',
  },
  {
    icon: 'ri-close-circle-line',
    title: '无法获得安全更新',
    description: '破解版无法通过官方渠道更新，设备将长期暴露在已知漏洞之中，安全防护形同虚设。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '系统稳定性破坏',
    description: '破解修改破坏应用完整性，导致频繁闪退、系统卡顿、电池异常消耗，甚至损坏系统文件。',
  },
  {
    icon: 'ri-scales-line',
    title: '法律风险',
    description: '根据《著作权法》和《计算机软件保护条例》，使用和传播破解版属侵权行为，企业用户面临更严重的法律后果。',
  },
];

export default function RiskWarning() {
  return (
    <section className="py-14 md:py-20 bg-accent-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 px-4 py-1.5 rounded-full text-xs font-medium mb-4">
            <i className="ri-alert-fill"></i>
            <span className="whitespace-nowrap">⚠ 重要安全警示</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            91破解版的安全隐患
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            安装破解版应用不仅仅是"省了几块钱"——以下是您需要认真对待的五大安全风险
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {risks.slice(0, 3).map((risk) => (
            <div key={risk.title} className="bg-white rounded-lg p-6 border border-accent-200/70">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${risk.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{risk.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{risk.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {risks.slice(3).map((risk) => (
            <div key={risk.title} className="bg-white rounded-lg p-6 border border-accent-200/70">
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                <i className={`${risk.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{risk.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{risk.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/security-risks"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white px-8 py-3 rounded-lg font-medium text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多安全风险
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}